// @flow
import React, { PureComponent } from 'react';
import { withHelmet } from 'infrastructure/seo/Helmet';
import { STATUS_DEFAULT } from 'constants/statusConstants';
import type { Status } from 'types/Status';
import type { JoueurType } from 'types/Joueur';
import type { BlocContent } from 'types/NewsletterBloc';
import Sidebar from 'components/sidebar/Sidebar';
import Loading from 'components/fragments/Loading';
import BackgroundImage from 'components/fragments/BackgroundImage';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';

export type StateProps = {
  joueur: JoueurType,
  status: Status
};

type OwnProps = {
  match: {
    params: {
      slug: string
    }
  }
};
export type DispatchProps = {
  fetchJoueur: (slug: string) => void
};

type Props = StateProps & OwnProps & DispatchProps;

class Joueur extends PureComponent<Props> {
  componentDidMount() {
    this.props.fetchJoueur(this.props.match.params.slug);
  }

  componentDidUpdate(prevProps: Props) {
    const { slug } = this.props.match.params;
    if (prevProps.match.params.slug !== slug) {
      this.props.fetchJoueur(slug);
    }
  }

  renderTrueBlocs = (blocs: Array<BlocContent>): any => {
    return blocs.map((blocFigure, index) => <ContentBloc key={index} {...blocFigure} />);
  };

  // TODO : check variable with status
  render() {
    const {
      title,
      content,
      poste,
      dateNaissance,
      numInternational,
      logo,
      sidebar,
    } = this.props.joueur;

    if (this.props.status === STATUS_DEFAULT) {
      return <Loading />;
    }

    return (
      <>
        <section className="banner banner--compact">
          <div className="banner__thumbnail img-blue-dark">
          </div>
          <div className="container">
            <ol className="breadcrumb is-dark ft-h6 ft-up "><li></li></ol>
          </div>
        </section>
        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-9 bg-overflow">
              <section>
                <article className="player-detail row">
                  <div className="col col-lg-8on9">
                    <div className="row">
                      <div className="col col-lg-8on9 banner-over player-detail__head">
                        <BackgroundImage
                          className="player-portrait mb-3 mb-md-0"
                          illustration={ logo }
                        />
                        <div>
                          <h2 className="mb-1">{ title }</h2>
                          <span className="role mb-3 mb-md-2">{ poste.name }</span>
                          <ul>
                            { dateNaissance && dateNaissance !== '' && 
                            <li>
                              <span className="birthdate ft-h5">Né le</span>
                              <p>{ dateNaissance }</p>
                            </li> }
                            { numInternational && numInternational > 0 && 
                            <li>
                              <span className="number ft-h5">N° de joueur</span>
                              <p>{ numInternational }</p>
                            </li> }
                          </ul>
                        </div>
                      </div>
                    </div>
                    <h3 className="mb-3 mt-6">Biographie</h3>
                    { this.renderTrueBlocs(content) }
                  </div>
                </article>
              </section>
            </div>
            <Sidebar sidebarContent={sidebar}/>
          </div>
        </div>
      </>
    );
  }
}

export default withHelmet(Joueur)((Helmet, pageProps) => (
  <Helmet>
    <title>{pageProps.joueur.meta_title}</title>
    <meta name={'description'} content={pageProps.joueur.meta_description} />
  </Helmet>
));
